var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 13.4515V16.5L7.4216 13.4515H11.2C12.0824 13.4515 12.8 12.7254 12.8 11.8326V5.35682C12.8 4.46398 12.0824 3.73788 11.2 3.73788H1.6C0.7176 3.73788 0 4.46398 0 5.35682V11.8326C0 12.7254 0.7176 13.4515 1.6 13.4515H2.4ZM1.6 5.35682H11.2V11.8326H6.9784L4 13.6409V11.8326H1.6V5.35682Z",
    fill: "#6B7085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0.5H4.8C3.9176 0.5 3.2 1.2261 3.2 2.11894H12.8C13.6824 2.11894 14.4 2.84504 14.4 3.73788V10.2136C15.2824 10.2136 16 9.48755 16 8.59471V2.11894C16 1.2261 15.2824 0.5 14.4 0.5Z",
    fill: "#6B7085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.78a24ecb01624993229e6fe604b85a9a.svg";
export { ForwardRef as ReactComponent };